
export default {
  name: 'PortfolioCardWithDonutChartSkeleton',
};
